module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp3_8017.da5058d4.png";